export default {
  login: {
    login: "Login",
    reset: "Reset",
    userName: "Account",
    password: "Password",
    enterUserName: "Please enter your account",
    enterPassword: "Please enter your password",
  },
  route: {
    warehouseReceipt: "B2B Inbound / Outbound",
    warehouseReceiptInbound: "Inbound",
    warehouseReceiptOutbound: "Outbound",
    warehouseReceiptInboundImport: "Warehouse receipt inbound import",
    warehouseReceiptOutboundImport: "Warehouse receipt outbound import",
    warehouseReceiptAccountBookStock: "Account Book Stock",
    warehouseReceiptOperation: "Receipt Operations",
    warehouseReceiptExpiryStock: "Expiry Stock",
    home: "home",
    download: "download list",
    changePassword: "change pwd",

    order: "order manager",
    orderList: "order list",
    OpenPlatformOrderImport: "open platform order import",

    declare: "order manager",
    declareDetail: "declare detail",

    declareOrderList: "declare order list",
    customsDeclareDetail: "customs declare detail",

    warehouse: "warehouse",
    "ex-warehouseList": "ex-warehouse",

    goods: "goods",
    goodsForRecordList: "goods for record",
    goodsList: "goods list",

    taxesCommerce: "taxes commerce",
    taxCommerceAccountList: "tax commerce account",
    taxesCommerceStatistics: "taxes commerce statistics",
    taxesCommerceRechargeDetailList: "taxes commerce recharge detail list",
    taxesCommerceExpenseCalendarList: "taxes commerce expense calendar list",

    taxesClearanceCompany: "taxes clearance company",
    taxesClearanceCompanyStatistics: "taxes clearance company statistics",
    taxesClearanceCompanyRechargeDetailList:
      "taxes clearance company recharge detail list",
    taxesClearanceCompanyExpenseCalendarList:
      "taxes clearance company expense calendar list",

    taxesCommerceSupplier: "taxes commerce supplier",
    taxesCommerceSupplierStatistics: "taxes commerce supplier statistics",
    taxesCommerceSupplierRechargeDetailList:
      "taxes commerce supplier recharge detail list",
    taxesCommerceSupplierExpenseCalendarList:
      "taxes commerce supplier expense calendar list",

    stockControl: "stock control",

    carrierList: "carrier list",

    system: "system",

    role: "role",

    user: "oms user list",

    baseConfig: "base config info",

    exceptionTask: "exception task",

    channelView: "channel",
    declareEnterpriseView: "declare enterprise",
    merchantView: "merchant",
    channelEcommercePlatformView: "channel ecommerce platform",
    enterpriseAccountBookView: "enterprise account book",

    report: "report",
    nuclearNoteView: "nuclear note",

    goodsReturnManage: "goods return manage",
    returnQualityInspectionWorkbench: "return quality inspection workbench",
    returnQualityInspectionRecords: "return quality inspection records",
    goodsReturnDetail: "goods return detail",
    checkListManage: "check list manage",
    checkListDetail: "check list detail",
    booksManage: "books inventory",
    goodsRecordManage: "goods record manage",
    recordManage: "record manage",
    booksManageImport: "books manage import",
    nuclearNoteManage: "nuclearNoteManage",
    cancelLationsManage: "cancelLationsManage",
    orderActionRecord: "order action record",
    importPreview: "importPreview",
  },
};
